export const none = 'none' as const;

export const triggerPress = 'trigger-press' as const;
export const triggerHover = 'trigger-hover' as const;
export const triggerFocus = 'trigger-focus' as const;

export const outsidePress = 'outside-press' as const;
export const itemPress = 'item-press' as const;
export const closePress = 'close-press' as const;
export const linkPress = 'link-press' as const;
export const clearPress = 'clear-press' as const;
export const chipRemovePress = 'chip-remove-press' as const;
export const trackPress = 'track-press' as const;
export const incrementPress = 'increment-press' as const;
export const decrementPress = 'decrement-press' as const;

export const inputChange = 'input-change' as const;
export const inputClear = 'input-clear' as const;
export const inputBlur = 'input-blur' as const;
export const inputPaste = 'input-paste' as const;
export const inputPress = 'input-press' as const;

export const focusOut = 'focus-out' as const;
export const escapeKey = 'escape-key' as const;
export const closeWatcher = 'close-watcher' as const;
export const listNavigation = 'list-navigation' as const;
export const keyboard = 'keyboard' as const;

export const pointer = 'pointer' as const;
export const drag = 'drag' as const;
export const wheel = 'wheel' as const;
export const scrub = 'scrub' as const;

export const cancelOpen = 'cancel-open' as const;
export const siblingOpen = 'sibling-open' as const;
export const disabled = 'disabled' as const;
export const missing = 'missing' as const;
export const initial = 'initial' as const;
export const imperativeAction = 'imperative-action' as const;
export const swipe = 'swipe' as const;

export const windowResize = 'window-resize' as const;
